import { GET_LIST, GET_ONE, CREATE, fetchUtils } from 'react-admin';
import queryString from 'query-string';
import { getApiUrlForResource } from '../services/apiUrlResolver';

export const LEAD_IMPORTS_RESOURCE_NAME = 'lead-imports';

// Helper function to get API URL at request time
const getApiUrl = () => getApiUrlForResource('leadImports'); // Use camelCase for flag mapping

const prepareFilters = (filters) => {
  if (!filters) return {};

  const resultFilters = {};

  if (filters.filename) {
    resultFilters.filename = filters.filename;
  }

  if (filters.status) {
    resultFilters.status = filters.status
  }

  if (filters.source_org) {
    resultFilters.source_org = filters.source_org
  }

  if (filters.batch_id) {
    resultFilters.batch_id = {
      operation: 'contains',
      value: filters.batch_id,
    };
  }

  if (filters.triggered_by) {
    resultFilters.triggered_by = {
      operation: 'contains',
      value: filters.triggered_by,
    };
  }


  if (filters.createdBetween) {
    const { gte, lte } = filters.createdBetween;

    if (gte && lte) {
      resultFilters.created_at = {
        startPeriod: gte,
        endPeriod: lte,
      };
    } else if (gte) {
      resultFilters.created_at = {
        startPeriod: gte,
      };
    } else if (lte) {
      resultFilters.created_at = {
        endPeriod: lte,
      };
    }
  }

  return resultFilters;
};

const providerRequestToHttpRequest = (requestType, requestParams) => {
  switch (requestType) {
    case GET_LIST: {
      const { page, perPage } = requestParams.pagination;
      const { field, order } = requestParams.sort;

      const query = {
        sort: JSON.stringify([field, order]),
        range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
        filters: JSON.stringify(prepareFilters(requestParams.filter)),
        // Add cache-busting timestamp to ensure fresh data
        _t: Date.now(),
      };

      return {
        url: `${getApiUrl()}/${LEAD_IMPORTS_RESOURCE_NAME}?${queryString.stringify(query)}`,
      };
    }

    case GET_ONE:
      return {
        url: `${getApiUrl()}/${LEAD_IMPORTS_RESOURCE_NAME}/${requestParams.id}?_t=${Date.now()}`,
      };

    case CREATE:
      return {
        url: `${getApiUrl()}/${LEAD_IMPORTS_RESOURCE_NAME}/upload`,
        options: {
          method: 'POST',
          body: JSON.stringify(requestParams.data),
        },
      };

    default:
      throw new Error(`Unsupported fetch action type ${requestType}`);
  }
};

const httpResponseToProviderData = (response, type, params) => {
  const { headers, json } = response;

  switch (type) {
    case GET_LIST:
      return {
        data: json?.data?.map((item) => ({ ...item, id: item.batchId })),
        total: json?.total,
      };

    case GET_ONE:
      return { data: json };

    case CREATE:
      return { data: { ...json, id: json.batchId } };

    default:
      return { data: json };
  }
};

// Provider interface following standard pattern
const providerInterface = {
  providerRequestToHttpRequest,
  httpResponseToProviderData,
};

// Standard export format
export default {
  resource: LEAD_IMPORTS_RESOURCE_NAME,
  providerInterface,
};
